module.exports = __webpack_public_path__ + "img/w.2e2f1a95.jpg";